export default __webpack_public_path__ + "static/media/plant2.f7180a3e.PNG";